import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Briefcase, Users, UsersRound, LogOut, ExternalLink, FileStack } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS } from "../data/content";

const MENU = [
  { to: "/staff", label: "Command Center", icon: LayoutDashboard, end: true },
  { to: "/staff/cases", label: "Cases & Leads", icon: Briefcase },
  { to: "/staff/clients", label: "Clients", icon: Users },
  { to: "/staff/forms", label: "Forms Library", icon: FileStack },
  { to: "/staff/team", label: "Team & Roles", icon: UsersRound, adminOnly: true },
];

export default function StaffLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-sand/50 flex flex-col" data-testid="staff-layout">
      <header className="sticky top-0 z-40 bg-navy-dark border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" aria-label="CF Full Circle home"><Logo size={36} light /></Link>
          <div className="flex items-center gap-4">
            <span className="hidden sm:inline text-xs text-cream/60">{user?.name} · <span className="text-champagne font-medium">{ROLE_LABELS[user?.role] || user?.role}</span></span>
            <Link to="/portal" className="hidden sm:flex items-center gap-1 text-xs text-cream/70 hover:text-champagne transition-colors" data-testid="switch-to-portal-link">
              <ExternalLink className="h-3.5 w-3.5" /> Client View
            </Link>
            <button onClick={handleLogout} className="flex items-center gap-1.5 text-sm text-cream/70 hover:text-champagne transition-colors" data-testid="staff-logout-button">
              <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Sign out</span>
            </button>
          </div>
        </div>
      </header>

      <div className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col lg:flex-row gap-8">
        <nav className="lg:w-56 flex-shrink-0" aria-label="Staff navigation">
          <div className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible pb-2 lg:pb-0">
            {MENU.filter((m) => !m.adminOnly || user?.role === "administrator").map((m) => (
              <NavLink
                key={m.to}
                to={m.to}
                end={m.end}
                data-testid={`staff-nav-${m.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-4 py-2.5 rounded-xl text-sm font-medium whitespace-nowrap transition-colors ${isActive ? "bg-teal text-white" : "text-mutedink hover:bg-white/5 hover:text-white"}`
                }
              >
                <m.icon className="h-4 w-4" /> {m.label}
              </NavLink>
            ))}
          </div>
        </nav>
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
